import { forwardRef, type InputHTMLAttributes } from 'react'
import { cx } from './cx'
import s from './Input.module.css'

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return <input ref={ref} className={cx(s.input, className)} {...rest} />
  },
)
